import cuid from 'cuid';

export default function generateRandomString() {
    return cuid();
}
